import { formatUnits } from "@ethersproject/units";

export const parseStyle = (value) => {
  const tokens = value.split(";");

  const styles = tokens.reduce((obj, st) => {
    const values = st.split(":");
    if (values.length > 1) {
      obj[values[0]] = values[1];
    }
    return obj;
  }, {});

  return styles;
};

export const parseBalance = (value, decimals = 18, decimalsToDisplay = 3) =>
  parseFloat(formatUnits(value, decimals)).toFixed(decimalsToDisplay);
